/**
 * 项目localstorage配置
 */
export default {
  // 登录token
  TOKEN: "token",
  // 租户id
  TENANT_ID: "tenant-id",
  // 用户端
  BID: "bid",
};
